import { createContext } from "react";
import { createAnalytics } from "./hooks/useAnalytics";

export const AnalyticsContext = createContext<ReturnType<typeof createAnalytics> | null>(null);
